import React from 'react'
import SettingFormModal from '../generatedFormModal/SettingFormModal'

const AddSetting=({currentRecord}:{currentRecord?:any})=> {
  return (
    <div>
     <SettingFormModal isEdit={false} currentRecord={{
        name:"",
        id:"",
        email:"",
     }}/> 
    </div>
  )
}

export default AddSetting